import { ActivityFilterKey, ActivityFilterModel } from '../domain';
import { useFilter } from '../../filter';
import { StorageKeys } from '../../storage';

// A map, not a ternary: a ternary only ever resolves to one of two branches,
// so a third ActivityFilterKey member (as AccountActivity was) silently falls
// into the `else` arm and shares storage with whatever that arm names. This
// mirrors useSetActivityListFilter's map so read and write can never drift
// onto different keys for the same ActivityFilterKey.
const STORAGE_KEY_BY_FILTER_KEY: Record<ActivityFilterKey, keyof StorageKeys> = {
  [ActivityFilterKey.Activity]: 'activityFilter',
  [ActivityFilterKey.AssetActivity]: 'assetActivityFilter',
  [ActivityFilterKey.AccountActivity]: 'accountActivityFilter',
};

export const useActivityListFilter = (filterKey: ActivityFilterKey) => {
  const storageKey = STORAGE_KEY_BY_FILTER_KEY[filterKey];
  return useFilter(
    filterKey,
    storageKey,
    (filter: any) => new ActivityFilterModel(filter),
    true
  );
};
